export default {
	course: {
		id: 'ID',
		title: 'Title',
		slug: 'Slug',
		description: 'Description',
		shortDescription: 'Short description',
		coverImage: 'Cover image',
		language: 'Language',
		isPublished: 'Published',
		isCollection: 'Collection',
		accessLevel: 'Access level',
		collectionType: 'Program type',
		featuredRank: 'Featured rank',
		isTemplate: 'Template',
		owner: 'Owner',
		ownerEmail: 'Owner email',
		category: 'Category',
		moduleCount: 'Modules',
		topicCount: 'Topics',
		resourceCount: 'Resources',
		enrollmentCount: 'Enrollments',
		instanceCount: 'Instances',
		stats: 'Stats',
		actions: 'Actions',
	},
	topic: {
		id: 'ID',
		title: 'Title',
		name: 'Name',
		slug: 'Slug',
		description: 'Description',
		position: 'Position',
		module: 'Module',
		course: '{{mainEntityLabel}}',
		linkedIn: 'Linked in {{mainEntityLabelPluralLower}}',
		resourceCount: 'Resources',
		progressCount: 'Progress',
		actions: 'Actions',
	},
	user: {
		id: 'ID',
		email: 'Email',
		username: 'Username',
		name: 'Name',
		accountStatus: 'Account status',
		subscriptionStatus: 'Subscription',
		accountStatusUpdatedAt: 'Status updated',
		accountStatusUpdatedBy: 'Status updated by',
		accountStatusReason: 'Status reason',
		courseEnrollmentCount: 'Course enrollments',
		collectionEnrollmentCount: 'Collection enrollments',
		ownedCourseCount: 'Owned courses',
		polarCustomerId: 'Polar customer ID',
		roles: 'Roles',
		roleCount: 'Role count',
		actions: 'Actions',
	},
	role: {
		id: 'ID',
		name: 'Name',
		description: 'Description',
		userCount: 'User count',
		actions: 'Actions',
	},
	module: {
		id: 'ID',
		title: 'Title',
		description: 'Description',
		position: 'Position',
		course: '{{mainEntityLabel}}',
		topicCount: 'Topics',
		isPublished: 'Published',
	},
	resource: {
		id: 'ID',
		title: 'Title',
		type: 'Type',
		url: 'URL',
		description: 'Description',
		topic: 'Topic',
		isCommented: 'Commented',
	},
	enrollment: {
		id: 'ID',
		user: 'User',
		course: '{{mainEntityLabel}}',
		status: 'Status',
		progress: 'Progress',
		createdAt: 'Enrolled',
		updatedAt: 'Updated',
	},
	category: {
		id: 'ID',
		name: 'Name',
		slug: 'Slug',
		description: 'Description',
		parentId: 'Parent ID',
		instructorPersonaId: 'Instructor persona',
		instructorPersonaRationale: 'Instructor rationale',
		editorialDomain: 'Editorial domain',
		editorialReaderIntent: 'Reader intent',
		editorialWritingGuidelines: 'Writing guidelines',
		editorialAvoid: 'Avoid',
		courseCount: '{{mainEntityLabelPlural}}',
		parentName: 'Parent name',
		actions: 'Actions',
		childrenCount: 'Child count',
	},
}
